<template>
    <v-container fluid grid-list-xs>
        <Loader ref="Loader"></Loader>
        <v-layout>
            <v-flex xs12 sm12 text-xs-center>
                <h3 style="font-size: 2em;">{{ TranslateText("Active Account Features")}}</h3>
                <br>
            </v-flex>
        </v-layout>
        <v-container xs12>
            <v-layout row wrap>
                <v-flex xs4 md6 lg6 xl6 v-for="item in features" :key="item.ID">
                    <v-card class="item">
                        <v-toolbar color="primary" dense>
                            <v-toolbar-title class="toolbar-title" style="text-align: center">{{ item.Name }}</v-toolbar-title>
                        </v-toolbar>
                        <br>
                        {{ item.Description }}
                        <br><br><br>
                        <!-- <v-layout align-end justify-end row fill-height ma-4>
                            <h2><b>${{ item.FeatureCost }}</b></h2>
                        </v-layout> -->
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-container>
</template>

<script>
    export default {
        data() {
            return {
                features: []
            }
        },
        mounted() {
            let self = this;

            self.fetchData();
        },
        created() {

        },
        methods: {
            routeTo(item) {
                let self = this;
                self.$router.push(item.route);
            },

            fetchData() {
                let self = this;

                self.$refs.Loader.show();
                self.get('AccountFeature/ActiveFeatures')
                    .then(response => {
                        self.$refs.Loader.hide();
                        console.log("[ACCOUNT-FEATURES]", response.data);
                        self.features = response.data;
                    })
            }
        },
    }
</script>

<style scoped>
    .toolbar-title {
        justify-content: flex-start !important;
        width: 100%;
    }

    .item {
        transition: 0.3s ease;
        cursor: pointer;
    }

    .item:hover {
        cursor: pointer;
        transform: scale(1.05, 1.05);
    }
</style>